import { AccentScheme, BaseScheme, Theme } from "@/store/user-config-store";

export interface ThemeSettings {
  theme: Theme;
  lightAccentScheme: AccentScheme;
  darkAccentScheme: AccentScheme;
  lightBaseScheme: BaseScheme;
  darkBaseScheme: BaseScheme;
}

export function applyThemeToDOM(settings: ThemeSettings) {
  const { theme, lightAccentScheme, darkAccentScheme, lightBaseScheme, darkBaseScheme } = settings;

  const resolvedTheme =
    theme === Theme.System ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light") : theme;

  const isLight = resolvedTheme === "light";
  const accentScheme = isLight ? lightAccentScheme : darkAccentScheme;
  const baseScheme = isLight ? lightBaseScheme : darkBaseScheme;

  const root = window.document.documentElement;
  const accentSchemeClasses = Array.from(root.classList).filter((c) => c.startsWith("accent-scheme-"));
  const baseSchemeClasses = Array.from(root.classList).filter((c) => c.startsWith("base-scheme-"));

  root.classList.remove("light", "dark", ...accentSchemeClasses, ...baseSchemeClasses);
  root.classList.add(resolvedTheme);

  if (accentScheme !== AccentScheme.Default) {
    root.classList.add(`accent-scheme-${accentScheme}`);
  }

  if (baseScheme !== BaseScheme.Default) {
    root.classList.add(`base-scheme-${baseScheme}`);
  }
}
